export default __webpack_public_path__ + "static/media/working-class.67ccda05.svg";